'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MoreDropDown = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styles = require('@material-ui/core/styles');

var _Button = require('@material-ui/core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _Menu = require('@material-ui/core/Menu');

var _Menu2 = _interopRequireDefault(_Menu);

var _MenuItem = require('@material-ui/core/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _ArrowDropDown = require('@material-ui/icons/ArrowDropDown');

var _ArrowDropDown2 = _interopRequireDefault(_ArrowDropDown);

var _constants = require('../constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = React.createElement(_ArrowDropDown2.default, null);

var MoreDropDown = exports.MoreDropDown = function (_React$Component) {
  (0, _inherits3.default)(MoreDropDown, _React$Component);

  function MoreDropDown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, MoreDropDown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MoreDropDown.__proto__ || (0, _getPrototypeOf2.default)(MoreDropDown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      anchorEl: undefined,
      open: false
    }, _this.onButtonClick = function (event) {
      _this.setState({
        open: true,
        anchorEl: event.currentTarget
      });
    }, _this.onCloseMenu = function () {
      _this.setState({
        open: false
      });
    }, _this.onMenuItemClick = function (url) {
      return function () {
        _this.props.history.push(url);
        _this.onCloseMenu();
      };
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(MoreDropDown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childMap = _props.childMap,
          classes = _props.classes;


      return React.createElement(
        'div',
        null,
        React.createElement(
          _Button2.default,
          {
            classes: {
              root: classes.buttonRoot
            },
            onClick: this.onButtonClick
          },
          'More ',
          _ref2
        ),
        React.createElement(
          _Menu2.default,
          {
            id: 'SecondaryNavMoreLinks',
            anchorEl: this.state.anchorEl,
            open: this.state.open,
            onClose: this.onCloseMenu
          },
          childMap.map(function (child) {
            var children = child.children,
                index = child.index,
                to = child.to;


            return React.createElement(
              _MenuItem2.default,
              {
                key: index,
                onClick: _this2.onMenuItemClick(to)
              },
              Array.isArray(children) ? children.join(' ') : children
            );
          })
        )
      );
    }
  }]);
  return MoreDropDown;
}(React.Component);

MoreDropDown.defaultProps = {
  classes: {},
  history: {
    push: function push() {}
  }
};


var styleSheet = function styleSheet(_ref3) {
  var _buttonRoot;

  var breakpoints = _ref3.breakpoints,
      palette = _ref3.palette;
  return {
    buttonRoot: (_buttonRoot = {
      color: palette.primary.contrastText,
      opacity: 0.7,
      paddingTop: 0,
      paddingBottom: 0,
      height: 48
    }, (0, _defineProperty3.default)(_buttonRoot, breakpoints.down('md'), {
      paddingLeft: _constants.TAB_PADDING_MAP.SM,
      paddingRight: _constants.TAB_PADDING_MAP.SM - _constants.ARROW_ICON_PADDING
    }), (0, _defineProperty3.default)(_buttonRoot, breakpoints.up('md'), {
      paddingLeft: _constants.TAB_PADDING_MAP.MD,
      paddingRight: _constants.TAB_PADDING_MAP.MD - _constants.ARROW_ICON_PADDING
    }), _buttonRoot)
  };
};

exports.default = (0, _styles.withStyles)(styleSheet)(MoreDropDown);